
@if(this.caisServiceService.FDIDScreenDataDetails){
<span>
<mat-list-item class="cais-list-item-title">FDID Details</mat-list-item>
<mat-divider></mat-divider>

<!-- FDID Field -->
<div class="ui-grid-col-12 container">
  @for (viewRow of fdidScreenDataDetails; track viewRow; let i = $index){
    @if(!viewRow.isOptionalFields){
      <span 
        [ngClass]="(editScreenNegotiatedFields.includes(viewRow.ui_Field_Name) || ExceptionalFDIDScreenFields.includes(viewRow.ui_Field_Name) ? 'notdisplay' : (viewRow.isLargeField ? 'zindex ui-g-12 ui-md-12 ui-lg-6' : 'zindex ui-g-12 ui-md-12 ui-lg-4'))">
        <span>
          <div class="ui-g-12 ui-md-12 ui-lg-12 quick-view-grid-row-hg">
            <div
              [ngClass]="(viewRow.isLargeField ? 'ui-g-12 ui-md-4 ui-lg-4 quick-view-grid-row-hg' : 'ui-g-12 ui-md-6 ui-lg-6 quick-view-grid-row-hg')">
              <label for="ui_Field_Name">{{viewRow.ui_Field_Name}}</label>
              @if(viewRow.isrequired){
              <strong class="error-mark">*</strong>
              }
            </div>
            <!-- Switch for preserving Important Field value -->
            @if(editDisabledFields.includes(viewRow.ui_Field_Name)){
            <div
              [ngClass]="'ui-g-12 ui-md-1 ui-lg-1 quick-view-grid-row-hg'">
              <span>
                <ng-container>
                  <p-toggleswitch (onChange)="viewRow.isDisable = !$event.checked;" styleClass="fdidInputSwitch"></p-toggleswitch>
                </ng-container>
              </span>
            </div>
          }
            <!-- End of Switch for preserving Important Field value -->
            <div
              [ngClass]="(viewRow.isLargeField ? (editDisabledFields.includes(viewRow.ui_Field_Name) ? 'ui-g-12 ui-md-7 ui-lg-7 quick-view-grid-row-hg' : 'ui-g-12 ui-md-8 ui-lg-8 quick-view-grid-row-hg') : 'ui-g-12 ui-md-6 ui-lg-6 quick-view-grid-row-hg')">
              <span>
                @if((viewRow?.datatype | lowercase) === 'string' && (viewRow?.dropdown | lowercase) === 'no'){
                <ng-container>
                  <input pInputText [id]="viewRow.field_Name+'string'"
                    [(ngModel)]="this.caisServiceService.FDIDScreenDataDetails[viewRow.field_Name]"
                    [disabled]="viewRow.isDisable || ([viewRow.field_Name].includes('DVPCustodianID') && this.caisServiceService.FDIDScreenDataDetails['accountType'] && !this.caisServiceService.FDIDScreenDataDetails['accountType'].includes('DVP/RVP'))"
                    [maxlength]="viewRow.maximumLength" [placeholder]="(viewRow.placeholder ? viewRow.placeholder : '')"
                    [attr.data-multiEditDisabled]="viewRow.isMultiDisabled" autocomplete="off"
                    [ngClass]="(this.caisServiceService.FDIDScreenDataDetails.errorFields && this.caisServiceService.FDIDScreenDataDetails['errorFields'][viewRow.field_Name]) ? 'errorField' : 'icon-input'"
                    (ngModelChange)="this.caisServiceService.FDIDScreenDataDetails[viewRow.field_Name] = ['accountNumber', 'accountName'].includes(viewRow.field_Name) ? $event.toUpperCase() : this.caisServiceService.FDIDScreenDataDetails[viewRow.field_Name]" />
                  <span
                    [ngClass]="(this.caisServiceService.FDIDScreenDataDetails.errorFields && this.caisServiceService.FDIDScreenDataDetails['errorFields'][viewRow.field_Name]) ? 'text-error' : ''">{{((this.caisServiceService.FDIDScreenDataDetails.errorFields
                    && this.caisServiceService.FDIDScreenDataDetails['errorFields'][viewRow.field_Name]) ?
                    this.caisServiceService.FDIDScreenDataDetails['errorFields'][viewRow.field_Name] : '')}}</span>
                </ng-container>
              }
              @if((viewRow?.datatype | lowercase) === 'date'){
                <ng-container>
                  <p-datepicker
                  [touchUI]="true"
                  inputId="basic"
                  [placeholder]="(viewRow.placeholder ? viewRow.placeholder : '')"
                  [(ngModel)]="this.caisServiceService.FDIDScreenDataDetails[viewRow.field_Name]"
                  [disabled]="viewRow.isDisable"
                  dateFormat="yy-mm-dd"
                  appendTo="body"
                  [ngClass]="(this.caisServiceService.FDIDScreenDataDetails.errorFields && this.caisServiceService.FDIDScreenDataDetails['errorFields'][viewRow.field_Name]) ? 'errorDateField' : ''"
                  placeholder="YYYY-MM-DD"
                  [motionOptions]="{ duration: 0 }"
                ></p-datepicker>
                  <span
                    [ngClass]="(this.caisServiceService.FDIDScreenDataDetails.errorFields && this.caisServiceService.FDIDScreenDataDetails['errorFields'][viewRow.field_Name]) ? 'text-error' : ''">{{((this.caisServiceService.FDIDScreenDataDetails.errorFields
                    && this.caisServiceService.FDIDScreenDataDetails['errorFields'][viewRow.field_Name]) ?
                    this.caisServiceService.FDIDScreenDataDetails['errorFields'][viewRow.field_Name] : '')}}</span>
                </ng-container>
              }
              @if((viewRow?.datatype | lowercase) === 'string' && (viewRow?.dropdown | lowercase) === 'yes' && (viewRow?.dropdowntype | lowercase) === 'singleselect'){
                <ng-container>
                  <p-select appendTo="body" [name]="viewRow.field_Name +'singleselect'"
                    [id]="viewRow.field_Name+'singleselect'" [options]="viewRow.dropdownvalue"
                    [(ngModel)]="this.caisServiceService.FDIDScreenDataDetails[viewRow.field_Name]" [showClear]="true"
                    [disabled]="viewRow.isDisable" [placeholder]="'Enter Value'"  [filter]="true" class="ui-dropdown-edit maxChoiceWidth"
                    [ngClass]="(this.caisServiceService.FDIDScreenDataDetails.errorFields && this.caisServiceService.FDIDScreenDataDetails['errorFields'][viewRow.field_Name]) ? 'errorDropdownField' : ''"
                    styleClass ="fdid-record-form-dropdown">
                  </p-select>
                  <span
                    [ngClass]="(this.caisServiceService.FDIDScreenDataDetails.errorFields && this.caisServiceService.FDIDScreenDataDetails['errorFields'][viewRow.field_Name]) ? 'text-error' : ''">{{((this.caisServiceService.FDIDScreenDataDetails.errorFields
                    && this.caisServiceService.FDIDScreenDataDetails['errorFields'][viewRow.field_Name]) ?
                    this.caisServiceService.FDIDScreenDataDetails['errorFields'][viewRow.field_Name] : '')}}</span>
                </ng-container>
              }
              @if((viewRow?.datatype | lowercase) === 'array' && (viewRow?.dropdown | lowercase) === 'yes' && (viewRow?.dropdowntype | lowercase) === 'multiselect'){
                <ng-container>
                  <p-multiSelect appendTo="body" [name]="viewRow.field_Name +'array'" [id]="viewRow.field_Name+'array'"
                    [options]="viewRow.dropdownvalue" [(ngModel)]="this.caisServiceService.FDIDScreenDataDetails[viewRow.field_Name]"
                    [disabled]="viewRow.isDisable" placeholder="'Please select choices'"
                    class=" ui-multiselect-edit maxMultiChoiceWidth fdid-record-multiselect-dropdown"
                    [ngClass]="(this.caisServiceService.FDIDScreenDataDetails.errorFields && this.caisServiceService.FDIDScreenDataDetails['errorFields'][viewRow.field_Name]) ? 'errorDropdownField' : ''">
                  </p-multiSelect>
                  <span
                    [ngClass]="(this.caisServiceService.FDIDScreenDataDetails.errorFields && this.caisServiceService.FDIDScreenDataDetails['errorFields'][viewRow.field_Name]) ? 'text-error' : ''">{{((this.caisServiceService.FDIDScreenDataDetails.errorFields
                    && this.caisServiceService.FDIDScreenDataDetails['errorFields'][viewRow.field_Name]) ?
                    this.caisServiceService.FDIDScreenDataDetails['errorFields'][viewRow.field_Name] : '')}}</span>
                </ng-container>
              }
              @if((viewRow?.dropdown | lowercase) === 'no' && !viewRow.isDisable && (viewRow?.datatype | lowercase) != 'date'){
                <span>
                  <a aria-label="Clear Value"> <i pTooltip="Clear Value" (click)="this.caisServiceService.FDIDScreenDataDetails[viewRow.field_Name]=null"
                      tooltipPosition="right" class="fa fa-times times-icon" aria-hidden="true"></i></a>
                </span>
              }
              </span>
            </div>
          </div>
        </span>
      </span>
    }
  }
</div>
<!-- End of FDID  Field -->
</span>
}